export const EMAIL_INTERVALS = ['daily', 'weekly', 'biweekly', 'monthly'];
export const SURVEY_EMAIL_INTERVALS = [
  { display: 'Daily', value: 'daily' },
  { display: 'Weekly', value: 'weekly' },
  { display: 'Bi Weekly', value: 'biweekly' },
  { display: 'Monthly', value: 'monthly' },
];
export const COMMENT_EMAIL_INTERVALS = [
  { display: 'Real Time', value: 'real_time' },
  ...SURVEY_EMAIL_INTERVALS,
];

export const SESSION_TIME_OUT_INTERVAL = 29 * 60 * 1000;

export const LOCAL_STORAGE_CONSTANTS = {
  CONFIRMED: 'confirmed',
  CONFIRMATION_GRACE_PERIOD: 'confirmationGracePeriod',
  SESSION_TIME_OUT: 'sessionTimeOut',
  USER_ID: 'userId',
  TOKEN: 'token',
  ROLE: 'role',
  QUESTION_ATTRIBUTES: 'questionAttributes',
  BUSINESS_ID: 'businessId',
  USER_INVITATION: 'userInvitation',
  DASHBOARD_METRICS: 'dashboardMetrics',
  SIGNUP_CONTACT_DETAILS: 'SIGNUP_CONTACT_DETAILS',
  SIGNUP_BUSINESS_DETAILS: 'SIGNUP_BUSINESS_DETAILS',
  ONBOARDING_STATUS: 'ONBOARDING_STATUS',
  SQ_NONCE: 'SQ_NONCE',
  BILLING_DETAILS: 'BILLING_DETAILS',
  SELECTED_SUGGESTED_TEMPLATE: 'SELECTED_SUGGESTED_TEMPLATE',
  SELECTED_TEMPLATES: 'SELECTED_TEMPLATES',
  PLAN_STATUS: 'PLAN_STATUS',
  REDEEMED_VOUCHER_CODE: 'REDEEMED_VOUCHER_CODE',
  SELECTED_PLAN: 'SELECTED_PLAN',
  PLAN_SUBSCRIPTION_STATUS: 'PLAN_SUBSCRIPTION_STATUS',
  BUSINESS_PLAN: 'BUSINESS_PLAN',
  SET_USER_PLAN: 'SET_USER_PLAN',
  USER_DATA: 'USER_DATA',
};

export const REG_EXP = {
  NAME: /^[a-zA-Z ]{2,30}$/,
  ZIP: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
  EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  PHONE: /^([0-9]( |-)?)?(\(?[0-9]{3}\)?|[0-9]{3})( |-)?([0-9]{3}( |-)?[0-9]{4}|[a-zA-Z0-9]{7})$/,
  WEBSITE: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/,
  DATE: /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/,
  CUSTOM_SURVEY: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
};

export const QUESTION_INPUT_TYPES = {
  SINGLE_CHOICE: 'Single Choice',
  MULTIPLE_CHOICE: 'Multiple Choice',
  NPS: 'NPS',
  COMMENT: 'Comment',
};

export const NPS_COLORS = {
  PROMOTERS: '#78DB77',
  PASSIVES: '#FFC068',
  DETRACTORS: '#FC7E79',
};



// WEBPACK FOOTER //
// ./src/constants/index.js